export default __webpack_public_path__ + "static/media/general_public.85e75898.png";